import { render, staticRenderFns } from "./CatalogFilterSidebar.vue?vue&type=template&id=3611b45a&scoped=true"
import script from "./CatalogFilterSidebar.vue?vue&type=script&lang=js"
export * from "./CatalogFilterSidebar.vue?vue&type=script&lang=js"
import style0 from "./CatalogFilterSidebar.vue?vue&type=style&index=0&id=3611b45a&prod&lang=scss"
import style1 from "./CatalogFilterSidebar.vue?vue&type=style&index=1&id=3611b45a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3611b45a",
  null
  
)

export default component.exports